import { useEffect, useState } from 'react';

// 00:17:34 — restarts automatically when it reaches zero.
const CYCLE_SECONDS = 17 * 60 + 34;
const startedAt = Date.now();

function getRemaining(): number {
  const elapsed = Math.floor((Date.now() - startedAt) / 1000);
  return CYCLE_SECONDS - (elapsed % CYCLE_SECONDS);
}

export function useCountdown() {
  const [remaining, setRemaining] = useState<number>(getRemaining);

  useEffect(() => {
    const id = window.setInterval(() => setRemaining(getRemaining()), 1000);
    return () => window.clearInterval(id);
  }, []);

  const hours = Math.floor(remaining / 3600);
  const minutes = Math.floor((remaining % 3600) / 60);
  const seconds = remaining % 60;

  return {
    hours: String(hours).padStart(2, '0'),
    minutes: String(minutes).padStart(2, '0'),
    seconds: String(seconds).padStart(2, '0'),
  };
}
